import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { TenantProvider } from './contexts/TenantContext';
import ProtectedRoute from './components/ProtectedRoute';
import BaseLayout from './components/layouts/BaseLayout';
import Profile from './components/Profile';
import Settings from './pages/Settings';
import SkillDiagnostic from './components/SkillDiagnostic';
import Login from './components/Login';
import AssessmentQuestions from './components/SkillDiagnostic/AssessmentQuestions';
import AssessmentSummary from './components/SkillDiagnostic/AssessmentSummary';
import { Dashboard, Progress } from './pages';
import { Practice } from './pages/Practice';
import QuickAssessment from './components/SkillDiagnostic/QuickAssessment';
import HRBot from './pages/HRBot';
import LearningResources from './pages/LearningResources';
import Coding from './pages/Coding';
import CodingProblemDetail from './pages/CodingProblemDetail';
import CorporateVocabulary from './pages/CorporateVocabulary';

const App: React.FC = () => {
  return (
      <ThemeProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
        <TenantProvider>
          <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
              <Route path="/:tenant/login" element={<Login />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute><BaseLayout><Outlet /></BaseLayout></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/:tenant" element={<Navigate to="/:tenant/dashboard" replace />} />
                <Route path="/:tenant/dashboard" element={<Dashboard />} />
                <Route path="/:tenant/profile" element={<Profile />} />
                <Route path="/:tenant/settings" element={<Settings />} />
                <Route path="/:tenant/skill-diagnostic" element={<SkillDiagnostic />} />
                <Route path="/:tenant/skill-diagnostic/quick" element={<QuickAssessment />} />
                <Route path="/:tenant/skill-diagnostic/start/:type" element={<AssessmentQuestions />} />
                <Route path="/:tenant/skill-diagnostic/:type/:id" element={<AssessmentQuestions />} />
                <Route path="/:tenant/skill-diagnostic/:type/:id/summary" element={<AssessmentSummary />} />
                <Route path="/:tenant/practice" element={<Practice />} />
                <Route path="/:tenant/progress" element={<Progress />} />
                <Route path="/:tenant/hr-bot" element={<HRBot />} />
                <Route path="/:tenant/learning-resources" element={<LearningResources />} />
                <Route path="/:tenant/coding" element={<Coding />} />
                <Route path="/:tenant/coding/:id" element={<CodingProblemDetail />} />
                <Route path="/:tenant/corporate-vocabulary" element={<CorporateVocabulary />} />
            </Route>
          </Routes>
          </AuthProvider>
        </TenantProvider>
        </Router>
      </ThemeProvider>
  );
};

export default App;
